/**
 * CDN/SwiftFederation template configurations
 * Matches: SwiftFederation.CDN, SwiftFederation.Transcoding, etc.
 */
import type { TemplateConfig, TemplateField } from '../types'
import { createExpandedRowRender } from '../../expanded-row'
import {
    defaultQuotaCalculator,
    defaultIsExpandable,
    DEFAULT_FIELDS,
} from '../shared'

// Re-export register form
export { default as SwiftFederationRegisterForm } from './register-form'

// ============================================================================
// Fields (CDN templates use default fields)
// ============================================================================

export const CDN_FIELDS: TemplateField[] = DEFAULT_FIELDS

// ============================================================================
// Template Configs
// ============================================================================

export const cdnTemplate: TemplateConfig = {
    id: 'cdn',
    patterns: ['swiftfederation.cdn'],
    priority: 10,
    fields: CDN_FIELDS,
    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },
    calculateQuota: defaultQuotaCalculator,
    registerForm: { type: 'swift-federation' },
}

export const transcodingTemplate: TemplateConfig = {
    id: 'transcoding',
    patterns: ['swiftfederation.transcoding'],
    priority: 10,
    fields: CDN_FIELDS,
    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },
    calculateQuota: defaultQuotaCalculator,
    registerForm: { type: 'swift-federation' },
}

export const transmuxingTemplate: TemplateConfig = {
    id: 'transmuxing',
    patterns: ['swiftfederation.transmuxing'],
    priority: 10,
    fields: CDN_FIELDS,
    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },
    calculateQuota: defaultQuotaCalculator,
    registerForm: { type: 'swift-federation' },
}

export const recordingTemplate: TemplateConfig = {
    id: 'recording',
    patterns: ['swiftfederation.recording'],
    priority: 10,
    fields: CDN_FIELDS,
    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },
    calculateQuota: defaultQuotaCalculator,
    registerForm: { type: 'swift-federation' },
}

export const storageLFDTemplate: TemplateConfig = {
    id: 'storage-lfd',
    patterns: ['swiftfederation.storagelfd'],
    priority: 10,
    fields: CDN_FIELDS,
    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },
    calculateQuota: defaultQuotaCalculator,
    registerForm: { type: 'swift-federation' },
}

export const storageOSSTemplate: TemplateConfig = {
    id: 'storage-oss',
    patterns: ['swiftfederation.storageoss'],
    priority: 10,
    fields: CDN_FIELDS,
    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },
    calculateQuota: defaultQuotaCalculator,
    registerForm: { type: 'swift-federation' },
}

// Export all CDN/SwiftFederation templates
export const cdnTemplates = [
    cdnTemplate,
    transcodingTemplate,
    transmuxingTemplate,
    recordingTemplate,
    storageLFDTemplate,
    storageOSSTemplate,
]
